module.exports = __webpack_public_path__ + "img/TruPath-7.88133a8c.jpg";